import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { DeletedStudiesQuery, DeletedStudiesQueryVariables } from '@/shared/api';
import DELETED_STUDIES_QUERY from '../queries/deletedStudies';

/**
 * Loads a filtered page of deleted studies for the recycle-bin list. Runs DELETED_STUDIES_QUERY and throws the first GraphQL error message when deletedStudies is nil.
 *
 * @param filter - Filter criteria forwarded to the GraphQL query.
 * @param limit - Maximum number of records to return, defaulting to 10.
 * @returns The deleted studies page.
 */
const fetchDeletedStudies = async (
  filter: DeletedStudiesQueryVariables['filter'],
  limit = 10,
): Promise<DeletedStudiesQuery['deletedStudies']> => {
  const client = createClient();
  const deletedStudiesResults = await client.query<
    DeletedStudiesQuery,
    DeletedStudiesQueryVariables
  >({
    query: DELETED_STUDIES_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data, errors } = deletedStudiesResults;
  const { deletedStudies } = data;
  if (_.isNil(deletedStudies) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return deletedStudies;
};

export default fetchDeletedStudies;
